import React from "react";
import "./WhyOnlineBcom.css";

const benefits = [
  {
    number: "01",
    title: "Flexible Online Learning",
    description:
      "Study through a flexible online learning model designed to support learners across different locations and professional or personal commitments.",
  },
  {
    number: "02",
    title: "Interdisciplinary Learning:",
    description:
      "Build knowledge across social sciences, humanities, politics, economics, psychology, sociology, governance and development.",
  },
  {
    number: "03",
    title: "Critical Thinking & Analytical Skills: ",
    description:
      "Learn to examine social realities, compare perspectives, interpret ideas and analyse contemporary issues using concepts and evidence.",
  },
  {
    number: "04",
    title: "Research & Academic Skills:",
    description:
      "Develop research aptitude through research methods, project work, academic writing and inquiry-based learning.",
  },
  {
    number: "05",
    title: "Communication & Digital Literacy: ",
    description:
      "Strengthen oral, written, interpersonal and digital communication skills for academic and professional environments.",
  },
  {
    number: "06",
    title: "Career & Higher Education Readiness: ",
    description:
      "Develop transferable skills relevant to areas such as administration, media, education, development, public policy, research and allied sectors, while building a foundation for higher studies.",
  },
  {
    number: "07",
    title: "Social & Civic Awareness: ",
    description:
      "Explore local, national and global issues through constitutional, democratic, intercultural and developmental perspectives.",
  },
];

const WhyOnlineBcom = () => {
  return (
    <section className="why-bcom-section">
      <div className="container">
        <div className="why-bcom-heading-wrapper">
          <h2 className="why-bcom-heading-title">
            Why an Online B.A. Might be the Right Choice for You
          </h2>
        </div>

        <div className="row">
          {benefits.map((benefit) => (
            <div className="col-12 col-md-6" key={benefit.number}>
              <div className="why-bcom-card">
                <div className="why-bcom-number-wrapper">
                  <span className="why-bcom-number">{benefit.number}</span>
                </div>

                <div className="why-bcom-content">
                  <h3 className="why-bcom-card-title">{benefit.title}</h3>

                  <p className="why-bcom-card-description">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyOnlineBcom;
